<template>
<div id="report-style" >
  <a href="javascript:window.print()" class="print-button">Print Report</a>
  <div id="report-to-print" class="d-flex .flex-*-fill flex-column bd-highlight">
    <div id="report-head" class="d-flex flex-column bd-highlight">
      <div class="d-flex flex-row bd-highlight">
        <div id="report-image" alt="logo"></div>
        <div id="report-header" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-2 bd-highlight"><b>PT. UNILEVER OLEOCHEMICAL INDONESIA</b></div>
          <div class="p-2 bd-highlight"><b><i>FORM INFORMASI DAN PERSETUJUAN PENARIKAN PRODUK</i></b></div>
          <div class="p-2 bd-highlight"><b><i>INFORMATION AND APPROVAL OF RECALL PRODUCT FORM</i></b></div>
        </div>
        <div id="report-sidebar" class="d-flex flex-fill flex-column bd-highlight">
          <div id="sidebar-border" class="p-1 bd-highlight">No Dok<br/>Ref</div>
          <div id="sidebar-border" class="p-1 bd-highlight">No Terbitan<br/>Issue No</div>
          <div id="sidebar-border" class="p-1 bd-highlight">Halaman<br/>Page No</div>
        </div>
        <div id="report-sidebar" class="d-flex flex-fill flex-column bd-highlight">
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>UOI - F- MR - 021</div>
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>01.1</div>
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>1 of 1</div>
        </div>
      </div>
    </div>
    
    <div id="borderline"></div>
    <br/>
    <div id="report-body-content" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight">Berikut ini kami informasikan mengenai rincian penarikan produk :<br/><i>Please find below list of recalling product</i></div>
        <!-- <div class="p-1 bd-highlight">{{cparcc.srNumber}}</div> -->
      </div>
    </div>
    <br/>

    <!-- Part A -->
    <div id="report-body-content" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>A. Deskripsi Produk dan Komplain/ <i>Product Description and Complaint</i></b></div>
        <!-- <div class="p-1 bd-highlight">{{cparcc.srNumber}}</div> -->
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar12" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">No Komplain<br/>Complaint No</div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar11" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{this.rcl.complaintNo}}</div>
      </div>
      <div id="report-sidebar12" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Pelanggan<br/>Customer</div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar14" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{this.rcl.customerName}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar12" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Kategori Komplain<br/>Complaint Category</div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar11" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1"></div>
      </div>
      <div id="report-sidebar12" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Kode Batch<br/>Batch No</div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar14" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{this.rcl.batch}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar12" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Nama Produk<br/>Product Name</div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar11" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{this.rcl.productName}}</div>
      </div>
      <div id="report-sidebar12" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Jumlah Recall<br/>Recall Qty</div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar14" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{Math.round(this.rcl.qty)}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    
    <br/>

    <!-- Part B -->
    <div id="report-body-content" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>B. Evaluasi risiko/ <i>Risk evaluation</i></b></div>
        <!-- <div class="p-1 bd-highlight">{{cparcc.srNumber}}</div> -->
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Hasil analisa retain sampel<br/><i>Analysis report of retain sample</i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{this.rcl.analysis}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Analisa akar permasalahan <br/><i>Root cause analysis</i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{this.rcl.cparNo}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Tahapan proses recall<br/><i>Recall process step</i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{this.rcl.recallProcessStep}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Tahapan proses penanganan produk tidak sesuai<br/><i>Handling nonconformities product process step
</i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{this.rcl.nonConformanceProcessStep}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>

    <br/>

    <!-- Part C -->
    <div id="report-body-content" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>C. Estimasi cost/ <i>Cost Estimation</i></b></div>
        <!-- <div class="p-1 bd-highlight">{{cparcc.srNumber}}</div> -->
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Biaya klaim dari pelanggan<br/><i>Claim Cost from Customer </i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{Math.round(this.rcl.claimCost)}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Biaya penanganan Recall <br/><i>Handling Recall Cost</i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{Math.round(this.rcl.handlingRecallCost)}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Biaya penanganan produk tidak sesuai<br/><i>Product nonconformance cost handling</i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{Math.round(this.rcl.nonConformanceHandlingCost)}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Biaya lainnya<br/><i>Biaya lainnya</i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{Math.round(this.rcl.otherCost)}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Total biaya<br/><i>Total cost</i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{Math.round(this.rcl.totalCost)}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>

    <br/>

    <!-- Part D -->
    <div id="report-body-content" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>D. Estimasi Waktu/ <i>Time Estimation</i></b></div>
        <!-- <div class="p-1 bd-highlight">{{cparcc.srNumber}}</div> -->
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Tanggal mulai penarikan<br/><i>Recall start time </i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{moment(this.rcl.recallStartDate).format("DD MMMM YYYY")}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Tanggal selesai penarikan <br/><i>Recall finish time</i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{moment(this.rcl.recallEndDate).format("DD MMMM YYYY")}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar15" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Total Waktu<br/><i>Total Days</i></div>
      </div>
      <div id="report-sidebar13" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">:</div>
      </div>
      <div id="report-sidebar16" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1">{{this.rcl.totalDays}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>

    <br/>

    <div id="report-body-content" class="d-flex justify-content-between">
      <div  class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Sei Mangkei, {{moment().format("DD MMMM YYYY")}}</div>
      </div>
    </div>
    <div id="borderline-body"></div>
    <div id="report-body3" class="d-flex justify-content-between">
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Dibuat oleh<br/><i>Prepared by,</i><br/><br/><br/><br/><br/><br/>Sales Manager</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Direview oleh<br/><i>Reviewed by,</i><br/><br/><br/><br/><br/><br/>Manufacturing Director</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Direview oleh<br/><i>Reviewed by,</i><br/><br/><br/><br/><br/><br/>Sales & Operations Director</div>
      </div>
      <div id="report-sidebar9" class="d-flex flex-fill flex-column bd-highlight">
        <div class="p-1 bd-highlight">Disetujui oleh<br/><i>Approved by,</i><br/><br/><br/><br/><br/><br/>Managing Director</div>
      </div>
    </div>
    <div id="borderline-body"></div>
  </div>
</div>
</template>

<script>
import moment from 'moment'
import api from '../../services/api'
import { recall } from '../../models/recallReport'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export default {
  components: {
    AppLookupField, AppDatatable, AppDatePicker
  },
  data() {
    return {
      rcl: {
        ...recall
      }
    }
  },
  async created() {
    if(this.$route.query.id !== undefined) {
      const rclApi = api('print/recall')
      this.rcl = await rclApi.getWithParams(this.$route.query.id)
    }
  },
  methods: {
    close() {
    //   this.$router.push({ name: 'approvedQuality' })
    },
    async exportToPdf() {
      const input = document.getElementById('report-to-print')
      const canvas = await html2canvas(input, {
        width: 1600,
        height: 2000
      })
      const imgData = canvas.toDataURL('image/png')

      const pdf = new jsPDF('l', 'mm', 'letter')
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()

      const currentTime = Date.now()
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight)
      pdf.save(`${this.rcl.complaintNo}.pdf`)
    }
  }
}
</script>